import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageNotFoundComponent} from './core/page-not-found/page-not-found.component';
import {DocsComponent} from './docs/docs.component';

const routes: Routes = [
  {path: '', component: DocsComponent},
  {path: 'docs', component: DocsComponent},
  {path: '**', pathMatch: 'full', component: PageNotFoundComponent, data: {title: 'PAGE_NOT_FOUND'}}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
